import img from "../image/electricl.png";
import img1 from "../image/HAVS.png";
import img2 from "../image/smart homen.jpg";
import img3 from "../image/general maintanance.png";
import img4 from "../image/kitchenn.jpg";
import img5 from "../image/ANNUAL MAINTANACEn.jpg";
import img6 from "../image/EMERGENCY.png";
import img8 from "../image/SAFTY INSPEC.png";

const subservicesData = [
  {
    slug: "mep",
    title: "Mechanical, Electrical & Plumbing (MEP)",
    image: img,
    longDescription:
      "Our MEP services ensure the reliable operation of essential building systems. We provide inspection, maintenance, and fault resolution for electrical, mechanical, and plumbing infrastructure across villas, apartments, offices, and commercial facilities.Electrical services include distribution boards, wiring systems, lighting, load testing, and backup power systems. Plumbing services cover water supply lines, concealed piping, drainage systems, pumps, heaters, and leak detection. Mechanical components are maintained with a focus on safety, efficiency, and compliance.Our preventive approach helps minimize disruptions, reduce emergency repairs, and extend system lifespan.",
    features: [
      "Electrical Maintenance",
      "Plumbing Services",
      "Mechanical Systems Support",
      "24/7 Emergency Service",
    ],
    seoTitle: "MEP Services in Dubai | Electrical & Plumbing Experts",
    seoDescription:
      "Professional MEP services in Dubai including electrical, plumbing and mechanical maintenance.",
    keywords: "MEP services Dubai, electrical maintenance, plumbing services",
  },

  {
    slug: "hvac",
    title: "HVAC Services",
    image: img1,
    longDescription:
      "We deliver comprehensive HVAC maintenance solutions designed to ensure consistent indoor comfort and efficient system performance. Our services cover central air conditioning, VRF/VRV systems, chillers, air handling units, fan coil units, thermostats, and zoning controls.Maintenance includes inspections, cleaning, airflow optimization, refrigerant checks, performance tuning, and fault diagnosis. By focusing on preventive servicing, we help improve energy efficiency, maintain indoor air quality, and reduce unexpected system failures.",
    features: [
      "AC Repair & Installation",
      "Duct Cleaning",
      "Preventive Maintenance",
      "Energy Efficient Solutions",
    ],
    seoTitle: "HVAC Services Dubai | AC Repair & Maintenance",
    seoDescription:
      "Trusted HVAC services in Dubai including AC repair, installation and annual maintenance.",
    keywords: "HVAC Dubai, AC repair Dubai, air conditioning services",
  },

  {
    slug: "smart-home",
    title: "Smart Home & Automation",
    image: img2,
    longDescription:
      "Our smart home and automation services support modern properties with integrated control systems. We maintain and troubleshoot systems for lighting, climate control, curtains, security, and audio-visual solutions.Services include system diagnostics, configuration support, upgrades, and coordination between connected devices. Our approach prioritizes reliability, compatibility, and ease of use, ensuring automation enhances comfort without unnecessary complexity.",
    features: [
      "Lighting Automation",
      "Smart Security Systems",
      "Home Control Integration",
      "Energy Monitoring",
    ],
    seoTitle: "Smart Home Automation Dubai | Home Technology",
    seoDescription:
      "Smart home automation solutions in Dubai for modern living and improved security.",
    keywords: "smart home Dubai, home automation, smart security",
  },

  {
    slug: "luxury-interior",
    title: "Luxury Interior & Finishes Care",
    image: img3,
    longDescription:
      "We provide interior maintenance services to preserve the appearance and functionality of premium spaces. This includes flooring, wall finishes, ceilings, carpentry, joinery, wardrobes, doors, and fittings.All work is carried out with care for material specifications and surrounding finishes. Our focus is on maintaining quality, durability, and consistency across all interior elements.",
    features: [
      "Interior Repairs",
      "Surface Restoration",
      "Luxury Material Care",
      "Detail-Oriented Service",
    ],
    seoTitle: "Luxury Interior Maintenance Dubai",
    seoDescription:
      "Specialized luxury interior maintenance services in Dubai for premium properties.",
    keywords: "luxury interior maintenance Dubai, interior care",
  },

  {
    slug: "kitchen-utilities",
    title: "Kitchen, Appliances & Utilities",
    image: img4,
    longDescription:
      "Our Kitchen Appliances & Utilities services ensure the reliable operation, safety, and efficiency of essential household and commercial kitchen systems. We provide structured maintenance, servicing, and inspections for built-in appliances and utility infrastructure, supporting uninterrupted daily operations.We work with luxury residential kitchens, staff kitchens, commercial pantry spaces, and light commercial kitchen environments, delivering services that prioritize performance, hygiene, and safety.",
    features: [
      "Appliance Repair",
      "Gas Line Maintenance",
      "Utility Inspections",
      "Quick Response",
    ],
    seoTitle: "Kitchen Appliance Repair Dubai",
    seoDescription:
      "Reliable kitchen appliance repair and maintenance services in Dubai.",
    keywords: "kitchen appliance repair Dubai, utility maintenance",
  },

  {
    slug: "amc",
    title: "Annual Maintenance Contracts (AMC)",
    image: img5,
    longDescription:
      "Our Annual Maintenance Contracts provide structured, long-term maintenance support for residential and commercial properties. AMC services include preventive maintenance, corrective works, emergency response, and scheduled inspections.Clients benefit from consistent service delivery, priority response, and predictable maintenance planning, helping protect property value and system performance over time.",
    features: [
      "Scheduled Maintenance",
      "Cost Effective Plans",
      "Priority Support",
      "Preventive Care",
    ],
    seoTitle: "Annual Maintenance Contract Dubai | AMC Services",
    seoDescription:
      "Affordable annual maintenance contract services in Dubai for residential and commercial properties.",
    keywords: "AMC Dubai, annual maintenance contract",
  },

  {
    slug: "energy-efficiency",
    title: "Energy, Sustainability & Efficiency",
    image: img6,
    longDescription:
      "Our Energy, Sustainability & Efficiency services are designed to optimize energy usage, reduce operational costs, and support environmentally responsible maintenance practices. We help properties improve performance while minimizing environmental impact through structured analysis and system optimization.Our services support luxury residential and commercial clients seeking efficient, responsible, and future-ready technical solutions.",
    features: [
      "Energy Audits",
      "Efficiency Optimization",
      "Sustainable Solutions",
      "Green Technology",
    ],
    seoTitle: "Energy Efficiency Services Dubai",
    seoDescription:
      "Energy efficiency and sustainability services in Dubai for smarter buildings.",
    keywords: "energy efficiency Dubai, sustainability services",
  },

  {
    slug: "civil-works",
    title: "Exterior, Structural & Civil Works",
    image: img8,
    longDescription:
      "Our Exterior, Structural & Civil Works services focus on maintaining the integrity, durability, and visual quality of building exteriors and architectural structures. We deliver professional maintenance and repair services designed to protect properties from environmental exposure and structural wear.These services support long-term durability, water resistance, and aesthetic preservation across villas, residential towers, commercial buildings, and mixed-use developments.",
    features: [
      "Structural Repairs",
      "Exterior Maintenance",
      "Civil Work Support",
      "Safety Inspections",
    ],
    seoTitle: "Structural & Civil Maintenance Dubai",
    seoDescription:
      "Professional structural and civil maintenance services in Dubai.",
    keywords: "civil works Dubai, structural maintenance",
  },
];

export default subservicesData;
